import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {inject, Injector} from '@angular/core';
import {ClientStore} from '../clientes-state/client-state.store';
import {CampaignStoreService} from '@/app/features/campaña/services/campaign-store.service';

export interface UserRole {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  attributes?: Record<string, any>;
  group: 'USER' | 'ADMIN';
}

export interface UserRoleState {
  user: UserRole | null;
}

function normalizeUser(parsedUser: any): UserRole {
  let normalizedGroup: 'USER' | 'ADMIN' = 'USER';
  switch (parsedUser.group) {
    case 'Client-Group':
      normalizedGroup = 'USER';
      break;
    case 'Admin-Group':
      normalizedGroup = 'ADMIN';
      break;
    default:
      normalizedGroup = parsedUser.group;
      break;
  }
  return {...parsedUser, group: normalizedGroup};
}

function loadUserFromLocalStorage(): UserRole | null {
  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return null;
    const parsed = JSON.parse(storedUser);
    return normalizeUser(parsed);
  } catch {
    return null;
  }
}

export const initialState: UserRoleState = {
  user: loadUserFromLocalStorage(),
};

export const UserRoleStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store, injector = inject(Injector)) => ({
    setUser(user: any) {
      const normalizedUser = normalizeUser(user);
      patchState(store, {user: normalizedUser});
      localStorage.setItem('user', JSON.stringify(normalizedUser));
    },
    resetData() {
      const clientStore = injector.get(ClientStore);
      const campaignStore = injector.get(CampaignStoreService);

      clientStore.resetData();
      campaignStore.clearCampaigns();
      localStorage.removeItem('user');
      localStorage.removeItem('currentClient');

      patchState(store, {user: null});
    },
  }))
);
